"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AclControl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _value = require("skybase-ui/skybase-core/utils/value");

var _hasAccess = require("./has-access");

var _constants = require("../oauth/constants");

var _utils = require("../utils");

var _acl = require("./acl");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _AclControl = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_AclControl, _PureComponent);

  var _super = _createSuper(_AclControl);

  function _AclControl() {
    var _this;

    (0, _classCallCheck2.default)(this, _AclControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasSomeRights", function (requestedPermssions, actualPermissions) {
      return requestedPermssions.some(function (permission) {
        return (0, _hasAccess.hasAccess)(actualPermissions, permission);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasAllRights", function (requestedPermssions, actualPermissions) {
      return requestedPermssions.every(function (permission) {
        return (0, _hasAccess.hasAccess)(actualPermissions, permission);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasReadRights", function () {
      var _this$props = _this.props,
          readPermissions = _this$props.readPermissions,
          permissions = _this$props.permissions,
          requireAll = _this$props.requireAll;
      if (!readPermissions) return false;
      return requireAll ? _this.hasAllRights(readPermissions, permissions) : _this.hasSomeRights(readPermissions, permissions);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasWriteRights", function () {
      var _this$props2 = _this.props,
          writePermissions = _this$props2.writePermissions,
          permissions = _this$props2.permissions,
          requireAll = _this$props2.requireAll;
      if (!writePermissions) return false;
      return requireAll ? _this.hasAllRights(writePermissions, permissions) : _this.hasSomeRights(writePermissions, permissions);
    });
    return _this;
  }

  (0, _createClass2.default)(_AclControl, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          writePermissions = _this$props3.writePermissions,
          overrideComponent = _this$props3.overrideComponent;
      var read = this.hasReadRights();
      var write = this.hasWriteRights();
      var aclRights = {
        read: read || (writePermissions ? write : false),
        write: write
      };
      return /*#__PURE__*/_react.default.createElement(_acl.Acl, {
        read: aclRights.read,
        write: aclRights.write,
        overrideComponent: overrideComponent
      }, children);
    }
  }]);
  return _AclControl;
}(_react.PureComponent);

(0, _defineProperty2.default)(_AclControl, "propTypes", {
  readPermissions: function readPermissions(props, propName) {
    // eslint-disable-line
    if ((0, _value.isNullOrUndefined)(props[propName]) && (0, _value.isNullOrUndefined)(props.writePermissions)) {
      return new Error('One of properties [readPermissions, writePermissions] props must be provided.');
    }

    if (!(0, _value.isNullOrUndefined)(props[propName]) && !Array.isArray(props[propName])) {
      return new Error("Property ".concat(propName, " must be an array of strings."));
    }
  },
  writePermissions: _propTypes.default.arrayOf(_propTypes.default.string),
  permissions: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  requireAll: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  overrideComponent: _propTypes.default.node
});
(0, _defineProperty2.default)(_AclControl, "defaultProps", {
  readPermissions: null,
  writePermissions: null,
  requireAll: false,
  overrideComponent: null
});

var mapStateToProps = function mapStateToProps(state) {
  var permissions = (0, _utils.getOAuthState)(state)[_constants.AUTH_STATE_KEY_NAME].permissions;

  return {
    permissions: permissions
  };
};

var AclControl = (0, _reactRedux.connect)(mapStateToProps)(_AclControl);
exports.AclControl = AclControl;
//# sourceMappingURL=acl-control.js.map